import { Alert, Button, notification, Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { editClientApi, resendClientVerificationApi } from '../../../../config/Api'
import { API_ERR_MESSAGE } from '../../../../config/constant'
import { readCookie } from '../../../../config/CookieScript'
import { checkLoginUserAccountType } from '../../../../config/constant'
import { apiErrorMessage } from '../../../../services/ApiError'
import { BookAppointment } from '../../../Appointments/components/BookAppointment'
import { CalendarOutlined } from '@ant-design/icons'
import { setHeaderName } from '../../../../services/SetHeaderName'
import { AssignDiet } from './components/AssignDiet/AssignDiet'
import { AssignedDiets } from './components/AssignDiet/components/AssignedDiets'
import { AssignedHerbsList } from './components/AssignedHerbs/AssignedHerbsList'
import { MedicalDetails } from './components/MedicalDetails'
import { PersonalDetails } from './components/PersonalDetails'
import { PhenotypeAnalysis } from './components/PhenotypeAnalysis/PhenotypeAnalysis'
import { TagsList } from './components/Tags/TagsList'
import { MeasurementsMaster } from './MeasurementsMaster'
import './style/PatientDetail.scss'

export const PatientDetail = () => {
    const { id } = useParams()
    // console.log(id)
    const [activeTabKey, setActiveTabKey] = useState('1')

    // General nutritionists don't do phenotype analysis, so they never get that tab
    const isAdmin = readCookie('role') == 'Admin'
    const isGeneralNutritionist = checkLoginUserAccountType() === 'Nutritionist General'
    const PHENOTYPE_TAB_KEY = '3'
    // the Make Notes tab was removed; notes now live in Medical Details
    const REMOVED_NOTES_TAB_KEY = '8'

    const [allPatientList, setAllPatientList] = useState([])
    const [patientData, setPatientData] = useState()
    const [tagData, setTagData] = useState(false)

    // get List of Patient List
    // const getListOfPatient = async () => {
    //     await listOfClientApi()
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setAllPatientList(res.data.data);
    //                 if (res.data.data.length > 0) {
    //                     const data = res.data.data.find((element) => element?.id == id)
    //                     console.log(data);
    //                     return setPatientData(data)
    //                     console.log(res.data.data.find((element) => element?.id == id))
    //                     console.log(patientData)
    //                 }
    //             }
    //         })
    //         .catch((err) => {
    //             notification.error({
    //                 message: API_ERR_MESSAGE,
    //             });
    //         });
    // }

    // get pheno type from patient detail
    const getDetailsOfPatient = async () => {
        await editClientApi(id)
            .then((res) => {
                if (res.status === 200) {
                    setPatientData(res.data.data)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    useEffect(() => {
        getDetailsOfPatient()
        setHeaderName('Patient Detail')
        // setDataSource(data)
        if (
            localStorage.getItem('activeTabKey') != undefined ||
            localStorage.getItem('activeTabKey') != null
        ) {
            const savedKey = localStorage.getItem('activeTabKey')
            // the remembered tab may be one this nutritionist can't see
            const hidden = savedKey === REMOVED_NOTES_TAB_KEY || (!isAdmin && isGeneralNutritionist && savedKey === PHENOTYPE_TAB_KEY)
            setActiveTabKey(hidden ? '1' : savedKey)
        }
    }, [activeTabKey])

    const [bookingOpen, setBookingOpen] = useState(false)
    // only the patient's own nutritionist books appointments for them
    const isOwnPatient = patientData && patientData.user_id == localStorage.getItem('id')

    const [sendingVerification, setSendingVerification] = useState(false)
    const resendVerification = () => {
        setSendingVerification(true)
        resendClientVerificationApi(id)
            .then((res) => notification.success({ message: res.data.message }))
            .catch((err) => notification.error({ message: apiErrorMessage(err) }))
            .finally(() => setSendingVerification(false))
    }

    // useEffect(() => {
    const onChange = (key) => {
        setActiveTabKey(key)
        localStorage.setItem('activeTabKey', key)
    }

    // after a successful save on a data entry tab, move on to the next tab that is shown
    // (Phenotype Analysis is skipped when it's hidden for this patient)
    const showPhenotype = isAdmin || (!isGeneralNutritionist && patientData?.phenotype_status == true)
    const tabOrder = ['1', '2', ...(showPhenotype ? ['3'] : []), '4', '5', '6', '9', '7']
    const goToNextTab = (fromKey) => {
        // an unverified patient's other tabs are locked, so stay on Personal Details
        if (fromKey === '1' && patientData && !patientData.is_email_verified) return
        const next = tabOrder[tabOrder.indexOf(fromKey) + 1]
        if (!next) return
        onChange(next)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <>
            {patientData && !patientData.is_email_verified && (
                <Alert
                    type="warning"
                    showIcon
                    className="mb-3"
                    message="This patient hasn't verified their email yet"
                    description={`Medical data, diets, herbs, measurements, tags and notes are locked until ${patientData.email} is verified. You can still view them and edit personal details.`}
                    action={
                        <Button size="small" loading={sendingVerification} onClick={resendVerification}>
                            Resend Verification Email
                        </Button>
                    }
                />
            )}
            {isOwnPatient && (
                <div className="text-end mb-2">
                    <Button icon={<CalendarOutlined />} onClick={() => setBookingOpen(true)}>
                        Book Appointment
                    </Button>
                </div>
            )}
            <BookAppointment open={bookingOpen} patientId={id} onClose={() => setBookingOpen(false)} />
            <Tabs
                activeKey={activeTabKey || '1'}
                // defaultActiveKey="1"
                onChange={onChange}
                type="card"
                tabPosition="top"
                className="clientDetailTabs"
            >
                <TabPane tab="Personal Details" key="1">
                    <PersonalDetails patientData={patientData} onSaved={() => goToNextTab('1')} />
                </TabPane>
                <TabPane tab="Medical Details" key="2">
                    <MedicalDetails onSaved={() => goToNextTab('2')} />
                </TabPane>
                {isAdmin ? (
                    <TabPane tab="Phenotype Analysis" key="3">
                        <PhenotypeAnalysis onSaved={() => goToNextTab('3')} />
                    </TabPane>
                ) : (
                    !isGeneralNutritionist && patientData?.phenotype_status == true && (
                        <TabPane tab="Phenotype Analysis" key="3">
                            <PhenotypeAnalysis onSaved={() => goToNextTab('3')} />
                        </TabPane>
                    )
                )}

                <TabPane tab="Measurements" key="4">
                    <MeasurementsMaster />
                </TabPane>
                <TabPane tab="Assign Herbs" key="5">
                    <AssignedHerbsList />
                </TabPane>
                <TabPane tab="Assign Diet" key="6">
                    <AssignDiet
                        tagData={tagData}
                        setTagData={setTagData}
                        patientData={patientData}
                        onChange={onChange}
                    />
                </TabPane>
                <TabPane tab="Assigned Diets" key="9">
                    <AssignedDiets onChange={onChange} />
                </TabPane>
                <TabPane tab="Tags" key="7">
                    <TagsList tagData={tagData} setTagData={setTagData} />
                </TabPane>
                {/* <TabPane tab="Blood Test Reports" key="9">
                    <BloodTestReports />
                </TabPane> */}
                {/* <TabPane tab="Send Email" key="10">
                    <SendEmail />
                </TabPane> */}
                {/* <TabPane tab="Send SMS" key="11">

                </TabPane>
                <TabPane tab="Feedback" key="12">
                    <FeedBack />
                </TabPane> */}
            </Tabs>

            {/* <Menu mode="horizontal" theme="dark" defaultSelectedKeys={['Personal Details']}>
                        <Menu.Item key="Personal Details">
                            <Link to="/personal-detail">Personal Details</Link>
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Medical Details">
                            Medical Details
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Phenotype Analysis">
                            Phenotype Analysis
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Measurements">
                            Measurements
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Assign Herbs">
                            Assign Herbs
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Assign Diet">
                            Assign Diet
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Tags">
                            Tags
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Blood Test Reports">
                            Blood Test Reports
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Send Email">
                            Send Email
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Send SMS">
                            Send SMS
                        </Menu.Item>
                        <Menu.Item onClick={() => setActiveKey} key="Feedback">
                            Feedback
                        </Menu.Item>
                    </Menu> */}
            {/* </Header> */}
        </>
    )
}
